const defaultConfig = {
  async: true,
  type: 'text/javascript',
  shouldPreprend: false,
  isHead: false,
};

export const loadScript = (url, callback, error, config = defaultConfig) => {
  var script = window.document.createElement('script');
  script.type = config.type || defaultConfig.type;
  script.async = config.async;

  if(script.readyState) {  //IE
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {  //Others
    script.onload = callback;
    script.onerror = error;
  }

  script.src = url;
  if(config.isHead===true)
  {
    window.document.head.appendChild(script);
  }
  else
  {
    config.shouldPrepend ?
    window.document.body.insertBefore(script, window.document.body.childNodes[0])
    :
    window.document.body.appendChild(script);
  }

  return script;
};



// WEBPACK FOOTER //
// ./src/helpers/script.js